import React, { useState } from "react";

// 13 Jun 2025
import { useGetUsersQuery } from "@/features/users/usersApiSlice";
import EtImprintCreation from "@/pages/home/web/userImprint/ImprintCreations/EtImprintCreation";

// 14 Jun 2025
import { useCreateNewUserCreationMutation } from '@/features/userCreations/userCreationsApiSlice'
import EtTrinityGuidedBlogFlow from "@/components/ai/EtTrinityGuidedBlogFlow"

const blogCreationPrompts = [
  { step: "observation", prompt: "What was a memorable observation from yesterday or today?" },
  { step: "insightType", prompt: "Do you see this as a problem or an opportunity?" },
  { step: "feeling", prompt: "How do you feel about this observation?" },
  { step: "actionIntent", prompt: "What would you like to do about this?" },
  { step: "audience", prompt: "Who will benefit from this perspective?" },
  { step: "challenges", prompt: "What challenges might come up?" },
  { step: "finalize", prompt: "Super! Based on your thoughts, I’ll now craft your blog draft. Ready?" },
];

const EtTrinityWriteBlog = ({ userId, onClose }) => {

  // First Created - 19 May 2025
  // Author - Atul Pandey
  // Purpose - Let the user capture early morning thoughts as blog ideas
  // Updated - 13 Jun 2025 - Add the EtImprintCreation component


  // 1 - Define State Variables
  const [viewTab, setViewTab] = useState("aiCapture");
  const [responses, setResponses] = useState({});

  // 2a - Define RTK mutations and queries
  const [createNewUserCreation, {
      isLoading,
      isSuccess,
      isError,
      error,
  }] = useCreateNewUserCreationMutation()
  
  // 2b - Get UserInfo
  const {data: usersData } = useGetUsersQuery()
    const userInfo = usersData?.ids.map(id => usersData?.entities[id])?.filter(user => user._id === userId)
  const userOrgId = userInfo[0]?.userOrgId?._id

  console.log('userInfo', userInfo)
  console.log('userOrgId', userOrgId)

  // 3 - Handle Prompt Response Changes
  const handlePromptResponseChange = (index, value) => {
    setResponses(prev => ({
      ...prev,
      [index]: value,
    }));
  };

  // 4 - Handler to submit blog as a user creation
  const handleFinalCreationResponse = async (finalResponse) => {
    try {
      const { userCreationName, userCreationDesc, ...userResponses  } = finalResponse;
      // console.log('finalResponse', finalResponse)
      // console.log('finalResponse.userCreationName', userCreationName)
      // console.log('finalResponse.userCreationDesc', userCreationDesc)
      // console.log('finalResponse.userResponses', userResponses)

      const payload = {
        userId: userId,
        userOrgId: userOrgId,
        userCreationName: userCreationName,
        userCreationDesc: userCreationDesc,
        userCreationAIContext: userResponses,
      };

      console.log('payload', payload)

      await createNewUserCreation(payload).unwrap();
      console.log("✅ Trinity generated blog saved as user creation.");
      alert("Your blog has been saved!");
    } catch (error) {
      console.error("❌ Error saving AI-generated creation:", error);
      alert("There was an error saving your blog.");
    }
  };

  return (
    <div className="p-4">

      <div className="flex justify-between items-center m-1 p-1">
          <p className="text-lg font-bold text-gray-800 mb-2">Capture a Fresh Creative Thought </p>
          <button onClick={onClose} className="mt-4 text-sm text-blue-600 underline">Close</button>
      </div>

      <div className="flex space-x-4 border-b border-gray-300 mb-4">
        <button
          onClick={() => setViewTab("aiCapture")}
          className={`text-sm font-semibold px-3 py-1 ${
            viewTab === "aiCapture"
              ? "border-b-2 border-orange-600 text-orange-800 bg-orange-200 rounded-t"
              : "text-gray-500"
          }`}
        >
          🧠 Trinity Way!
        </button>
        <button
          onClick={() => setViewTab("classicView")}
          className={`text-sm font-semibold px-3 py-1 ${
            viewTab === "classicView"
              ? "border-b-2 border-orange-600 text-orange-800 bg-orange-200 rounded-t"
              : "text-gray-500"
          }`}
        >
          {/* 🧱 Ceations Wall! */}
          🧱 Classic Way!
        </button>
      </div>


      {viewTab === "aiCapture" && (
        <div className="space-y-4">
          {/* 🧠 Header: Invite user to start capturing thoughts */}
          <div className="bg-white shadow rounded p-4 border border-gray-200 animate-fade-in">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">Start Building Your Perspective</h2>
            <p className="text-sm text-gray-800 bg-orange-50 rounded px-2 py-2 my-2 animate-slide-in-left">
              Capturing fresh thoughts isn't always easy — especially when your mind is juggling many threads. 
              Let’s break it down into a few simple parts. I’ll guide you through a set of seed inputs to help you get started.
            </p>
          </div>

          {/* ✍️ AI-Guided Blog Capture Flow */}
        <EtTrinityGuidedBlogFlow 
          context={userInfo}
          promptFlow={blogCreationPrompts}
          onComplete={handleFinalCreationResponse}
          // setIsOpen={setIsOpen}
        />
      </div>
      )}

      {viewTab === "classicView" && (
        <EtImprintCreation userId={userId} userInfo={userInfo} />
      )}
      
    </div>
  );
};

export default EtTrinityWriteBlog;